import React, { useContext,useCallback, useEffect, useState } from 'react';
import {isMobile, MobileView, BrowserView} from 'react-device-detect';
import { AppContext, UserContext } from '../../../AppContextProvider';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetch } from '../../api/FetchApiData';
import Select from 'react-select';
import { MediaUrl } from '../../utils/media/Media';
import { ButtonLoader } from '../../utils/Loaders/ButtonLoader';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { TicketView } from '../sales/Sale';
import { useInfiniteScroll } from '../../utils/InfiniteScroll';
import DeviceRegistration from '../device/Device';
import { useTranslation } from 'react-i18next';


if (isMobile)
    import('./partner_mob.css').then(() => {});
else
    import('./partner.css').then(() => {});


export function PartnerOrders({partner_id, close=()=>{}, close_btn=true})
{
    const [page,setPage] = useState({CurrentPage:1,MaxPage:1});
    const [hasMore,setHasMore] = useState(true);
    const [colis,setColis] = useState([]);
    const fetchData = useFetch();
    let _margin = '100px auto auto auto';
    let _with = '60%';
    let _height = ''
    if(isMobile)
    {
        _margin = '80px 0px auto 0px';
        _with = '95%';
    }

    useEffect(()=>{
        setPage(({CurrentPage:1,MaxPage:1}));
        setHasMore(true);
    },[partner_id]);

    const FetchOrders = useCallback(async ()=>{
        if(!hasMore || partner_id===undefined)
            return;
        if(page.CurrentPage<=page.MaxPage)
        {
            fetchData.GetData(`partners/colis/${partner_id}/1/${page.CurrentPage}/`).then((result)=>{
                if(result.result)
                {
                    if(page.CurrentPage>result.maxpage)
                        setHasMore(false);
                    else
                    {setColis([...colis,...result.items]);setPage({...page,CurrentPage:page.CurrentPage+1,MaxPage:result.maxpage});}
                }
            })
        }
    },[page.CurrentPage,hasMore]);

    const LoadMoreOrdersRef_ = useInfiniteScroll(FetchOrders,hasMore);

    let style_sheet = {width:"70%",padding:'20px',maxHeight:'50vh',overflowX:'hidden',margin:'30px auto auto auto',overflowY:'auto',backgroundColor:'white',border:'1px solid lightgray',borderRadius:'20px'};
    let ticket_sheet = {width:'15%',display:'inline-block',marginLeft:'5px',verticalAlign:'middle'};
    let info_ticket_sheet = {width:'55%',display:'inline-block',verticalAlign:'middle',textAlign:'center'};
    if(isMobile)
    {
      style_sheet = {...style_sheet,width:'85%',margin:'0px',maxHeight:'70vh',border:'none'};
      ticket_sheet = {...ticket_sheet,width:'25%'};
      info_ticket_sheet = {...info_ticket_sheet,fontSize:'x-small',width:'53%',textAlign:'center'};
    }


    return(
      <div style={style_sheet}>
          { (colis.length===0) &&
            <div style={{margin:'auto'}}>
                <span style={{fontSize:'xx-large',color:'gray'}}>
                    Aucun élement trouvé
                </span>
            </div>
          }
          {(colis.length>0) && colis.map((colis,index)=>{return(
              <div key={index} style={{borderBottom:'1px solid lightgray',fontSize:'small',width:'100%',padding:'5px 10px 15px 10px',textAlign:'center'}}>
                  <MobileView style={{display:'inline-block'}}>
                    <img src={MediaUrl(colis.image)} style={{width:'40px',height:'50px',objectFit:'cover',borderRadius:'5px',verticalAlign:'middle',margin:'0px'}} />
                  </MobileView>
                  <BrowserView style={{display:'inline-block'}}>
                    <img src={MediaUrl(colis.image)} style={{width:'80px',height:'100px',objectFit:'cover',borderRadius:'5px',verticalAlign:'middle',margin:'0px'}} />
                  </BrowserView>
                  <div style={info_ticket_sheet}>
                      <h4 style={{marginBottom:'5px'}}>{colis.title}</h4>
                      <span style={{color:'gray'}}>Numero Reference : {colis.order_number}</span><br/>
                      <span style={{color:'gray'}}>Quantité : {colis.quantity}</span><br/>
                      <span style={{color:'gray'}}>Client : {colis.client.label_name}</span><br/>
                      <span style={{color:'gray'}}>Téléphone : {colis.client.phone}</span><br/>
                      <span style={{marginLeft:'10px',color:'gray'}}>Addresse : {colis.address.display_name}</span><br/>
                      <span style={{color:'gray',display:'block'}}>Statut : {colis.status}</span>
                  </div>
                  <div style={ticket_sheet}>
                      <TicketView order={{order_number:colis.order_number,
                          customer:{label:colis.client.label_name, phone:colis.client.phone},
                          date:colis.date,
                          address:colis.address
                          }} qr_size={80} data_ticket={colis.package} title={'Ticket de livraison'} enable_download={true} show_info={false} />
                  </div>
              </div>
          )})}
          <div ref={LoadMoreOrdersRef_} style={{height:'20px'}}/>
          { 
            (close_btn) && <input type='button' style={{height:'35px',margin:'auto',marginTop:'10px',color:'black',width:'70%',borderRadius:'5px',backgroundColor:'#FFCCCB',border:'none'}} value={'Fermer'} onClick={e=>{close()}} />    
          }
      </div>);
}

function Partner({id}) {
  const [UserState,setUserState] = useContext(UserContext);
  const {t} = useTranslation();
  const [loading,setLoading] = useState({loading:false,text:t('user-info.enregistrer')});
  const navigator_ = useNavigate();
  const [_partner,setPartner] = useState({name:'',description:'',phone:'',email:'',identity:null,rib:null,logo:null,owned:false,device:null})
  const [locations,setLocations] = useState([]);
  const fetchData = useFetch();
  const [ville,setVille] = useState("");
  const [AppState,setAppState] = useContext(AppContext);
  const [users,setUSers] = useState([]);
  const [selectUser, setSelectedUser] = useState(null);
  const [showOrders,setShowOrders] = useState(false);
  const [isNotNew,setNotNew] = useState(!!id);


  const SelectOption=(loc)=>
  {
     return(
     <div>
        <label>{loc.label}</label><br/>
        <label style={{color:'gray'}}>{loc.display_name}</label>
     </div>)
  }

  useEffect(()=>{
    if(!UserState.is_staff && !(UserState.is_partner))
        navigator_('/');
    if(!!id && id!=='add')
      fetchData.GetData('partner/'+id+'/').then((result)=>{
          if(result.result)
          {
            if(!!result.partner.address)
              result.partner.address = {...result.partner.address,label:SelectOption(result.partner.address)}
            setPartner({...result.partner});
            let arr = [];
            result.partner.locations.forEach((loc)=>{
               arr.push({...loc,label:SelectOption(loc)})
            });
            setLocations(arr);
            const user = result.partner.owner_;
            setSelectedUser({value:user.email,locations:user.locations, label:
              <div>
                  <h4 style={{marginBottom:'5px',marginTop:'0px'}}>{user.labelname}</h4>
                  <div style={{marginBottom:'10px',color:'gray'}}>
                      <span style={{marginLeft:'20px'}}>Telephone : {user.phone}</span>
                      <span style={{marginLeft:'20px'}}>Email : {user.email}</span>
                  </div>
              </div>
            });
          }
      })
  },[])

  const UsersOptions=(users_)=>{
     let us = []
     users_.map((user)=>{
      us.push({value:user.email,locations:user.locations, label:
        <div style={{textAlign:'center'}}>
            <h4 style={{marginBottom:'0px',marginTop:'0px'}}>{user.labelname}</h4>
            <div style={{textAlign:'center',display:'flex',flexDirection:'row',alignItems:'center',justifyItems:'center',margin:'auto',marginBottom:'5px',color:'gray'}}>
                {(!!user.phone)&&<div style={{display:'flex',flexDirection:AppState.settings.lang==='ar'?'row-reverse':'row',margin:'auto'}}>
                  <span style={{marginLeft:'20px'}}>{t('authentication.telephone')}</span><span>  {user.phone}</span>
                </div>}
                <div style={{display:'flex',flexDirection:AppState.settings.lang==='ar'?'row-reverse':'row',marginLeft:'20px',margin:'auto'}}>
                  <span style={{marginLeft:'20px'}}>{t('authentication.email')}</span><span> {user.email}</span>
                </div>
            </div>
        </div>
      });
      if(user.email === _partner.email)
        setSelectedUser(user);
     });
     setUSers([...us]);
  }

  useEffect(()=>{
      fetchData.PostData({page:1},'user/users/').then((result)=>{
        if(result.result)
        {
          UsersOptions(result.users);
          const opt = result.users.find(us=>us.value===_partner.email);
          if(!!opt)
          {
            setSelectedUser(opt);
          }
        }
      })
  },[])

  useEffect(()=>{
     const opt = users.find(us=>us.value===_partner.email);
     if(!!opt)
     {
      setSelectedUser(opt);
      let arr = [];
      opt.locations.map((loc)=>{
        arr.push({value:loc.label,tag:loc,label:
          <div>
            <h4 style={{marginBottom:'5px',marginTop:'0px'}}>{loc.label}</h4>
            <div style={{marginBottom:'10px',color:'gray'}}>
              <span style={{marginLeft:'20px'}}>{loc.display_name}</span>
            </div>
          </div>
        })
      })
      setLocations([...arr]);
    }
  },[_partner.email])

  const SavePartner = ()=>
  {
    setLoading(true);
    let formData = new FormData();
    let _partner_ = {name:_partner.name,phone:_partner.phone,ville:'Moroni',description:_partner.description,email:_partner.email};
    const logo = _partner.logo;
    if(!!_partner.address)
      _partner_ = {..._partner_,address:_partner.address.tag}
    if(logo instanceof Blob)
      formData.append('logo',logo,logo.name);
    if( _partner.rib instanceof Blob)
      formData.append('rib',_partner.rib,_partner.rib.name);
    if(_partner.identity instanceof Blob)
      formData.append('identity',_partner.identity,_partner.identity.name);
    if(!!_partner.id)
    {
        _partner_ = {..._partner_,id:_partner.id};
        formData.append('data',JSON.stringify(_partner_));
        fetchData.PutFormData(formData,'partner/add/').then((result)=>{
            if(result.result)
            {
               setLoading({loading:false,text:'Données enregistrées'});
               setTimeout(()=>{setLoading({loading:false,text:'Enregister'});},5000);
            }
            else
            {
              setLoading({loading:false,text:'Erreur serveur'});
              setTimeout(()=>{setLoading({loading:false,text:'Enregister'});},5000);
            }
        })
    }
    else
    {
        formData.append('data',JSON.stringify(_partner_));
        fetchData.PostFormData(formData,'partner/add/').then((result)=>{
          if(result.result)
            {
               setLoading({loading:false,text:'Données enregistrées'});
               setTimeout(()=>{setLoading({loading:false,text:'Enregister'});},5000);
            }
            else
            {
              setLoading({loading:false,text:'Erreur serveur'});
              setTimeout(()=>{setLoading({loading:false,text:'Enregister'});},5000);
            }
          });
    } 
  }

  const RemoveImageFile = (image)=>{
    if(image instanceof Blob)
    {
        //_partner.logo.pop(image);
        setPartner({..._partner,logo:null});
    }
    else{
        fetchData.DeleteData(image,'image/').then((result)=>{
            if(result.result)
            {_partner.logo = null;setPartner({..._partner});}
        })
    }
  }

  const RemoveDocumentFile = (document,is_identite)=>{
    if(document instanceof Blob)
    {
      if(is_identite)
      {_partner.identity.pop(document);setPartner({..._partner});}
      else
        {_partner.rib = null;setPartner({..._partner});}
    }
    else{
        fetchData.DeleteData(document,'document/').then((result)=>{
            if(result.result)
            {
              if(is_identite)
              {_partner.identity = null;setPartner({..._partner});}
              else
              {_partner.rib = null;setPartner({..._partner});}
            }
        })
    }
  }

  const Identite = ()=>{
    if(isMobile)
    {
      if(!!_partner.identity)
      {
        let label = !!_partner.identity.title ? _partner.identity.title : _partner.identity.name;
        return(
        <div style={{minHeight:'22px',padding:'3px',width:'50%',backgroundColor:'lightgray',borderRadius:'5px',margin:'auto'}}>
          <label style={{display:'inline-block',paddingTop:'3px'}}>{label}</label>
          <span onClick={e=>{RemoveDocumentFile(_partner.identity,true)}} style={{float:'right',backgroundColor:'black',color:'white',padding:'5px',fontSize:'x-small',borderRadius:'3px'}}>X</span>      
        </div>);
      }
      else
      {
        return <input accept="application/pdf" disabled={!_partner.owned && !isNotNew} style={{border:'none'}} onChange={e=>{setPartner({..._partner,identity:e.target.files[0]});}} className='partner-input' type='file' multiple={false} />;
      }
    }
    else
    {
      if(!!_partner.identity)
      {
        let label = !!_partner.identity.title ? _partner.identity.title : _partner.identity.name;
        return(
        <div style={{position:'relative',minHeight:'25px',backgroundColor:'lightgray',borderRadius:'5px',width:'70%'}}>
          <label style={{display:'inline-block',width:'100%',paddingTop:'10px',paddingBottom:'10px'}}>{"Identité"}</label>
          <span onClick={e=>{RemoveDocumentFile(_partner.identity,true)}} style={{position:'absolute',backgroundColor:'black',color:'white',padding:'5px',fontSize:'x-small',borderRadius:'3px',top:'7px',right:'5px'}}>X</span>
        </div>);
      }
      else
      {return <input accept="application/pdf" disabled={!_partner.owned && !isNotNew} style={{border:'none'}} onChange={e=>{setPartner({..._partner,identity:e.target.files[0]});}} className='partner-input' type='file' multiple={false} />}
    }
  }

  const Rib = ()=>{
    if(isMobile)
    {
      if(!!_partner.rib)
      {
        let label = !!_partner.rib.title ? _partner.rib.title : _partner.rib.name;
        return(
        <div className='partner-input' style={{minHeight:'22px',padding:'3px',width:'50%',backgroundColor:'lightgray',borderRadius:'5px',margin:'auto'}}>
          <label style={{display:'inline-block',paddingTop:'3px'}}>{label}</label>
          <span onClick={e=>{RemoveDocumentFile(_partner.rib,false)}} style={{float:'right',backgroundColor:'black',color:'white',padding:'5px',fontSize:'x-small',borderRadius:'3px'}}>X</span>      
        </div>);
      }
      else
      {
        return <input accept="application/pdf" disabled={!_partner.owned && !isNotNew} style={{border:'none'}} onChange={e=>{setPartner({..._partner,rib:e.target.files[0]});}} className='partner-input' type='file' multiple={false} />;
      }
    }
    else
    {
      if(!!_partner.rib)
      {
        let label = !!_partner.rib.title ? _partner.rib.title : _partner.rib.name;
        return(
        <div className='patner-input' style={{width:'70%',minHeight:'25px',backgroundColor:'lightgray',borderRadius:'5px',position:'relative'}}>
          <label style={{display:'inline-block',width:'100%',paddingTop:'10px',paddingBottom:'10px'}}>{"RIB"}</label>
          <span onClick={e=>{RemoveDocumentFile(_partner.rib,false)}} style={{position:'absolute',backgroundColor:'black',color:'white',padding:'5px',fontSize:'x-small',borderRadius:'3px',top:'7px',right:'5px'}}>X</span>
        </div>);
      }
      else
      {return <input accept="application/pdf" disabled={!_partner.owned && !isNotNew} style={{border:'none'}} onChange={e=>{setPartner({..._partner,rib:e.target.files[0]});}} className='partner-input' type='file' multiple={false} />}
    }
  }

  const Logo = ()=>{
    let logo_src = '/images/icons/store.webp';
    try{logo_src = URL.createObjectURL(_partner.logo);}
    catch{
      try{logo_src = MediaUrl(_partner.logo.image);}
      catch{logo_src = '/images/icons/store.webp';}
    }
    if(isMobile)
    {
      if(!!_partner.logo)
      {return(
        <div className='partner-input' style={{border:'none'}}>
          <img src={logo_src} style={{width:'80px',height:'80px',margin:'auto',borderRadius:'40px'}} />
          <span onClick={e=>{RemoveImageFile(_partner.logo)}} style={{position:'absolute',backgroundColor:'black',color:'white',padding:'5px',fontSize:'x-small',borderRadius:'3px'}}>X</span>      
        </div>);
      }
      else
      {
        return <input disabled={!_partner.owned && !isNotNew} style={{border:'none'}} accept="image/png,image/jpeg,image/jpg" className='partner-input' type='file' multiple={false} onChange={e=>{setPartner({..._partner,logo:e.target.files[0]});}} />
      }
    }
    else
    {
      if(!!_partner.logo)
      {
        return(
        <div className='partner-input' style={{position:'relative'}}>
          <img src={logo_src} style={{width:'100px',height:'100px',margin:'auto',borderRadius:'50px'}} />
          <span onClick={e=>{RemoveImageFile(_partner.logo)}} style={{position:'absolute',backgroundColor:'black',color:'white',padding:'5px',fontSize:'x-small',borderRadius:'3px'}}>X</span>
        </div>);
      }
      else
      {return <input disabled={!_partner.owned && !isNotNew} style={{border:'none'}} accept="image/png,image/jpeg,image/jpg" className='partner-input' type='file' multiple={false} onChange={e=>{setPartner({..._partner,logo:e.target.files[0]});}} />}
    }
  }

  return (
    <div className='partner' >
      <div className='partner-div'>
        <label className='partner-label'>{t('authentication.nom')}</label>
        <input disabled={!_partner.owned && !isNotNew} value={_partner.name} onChange={e=>{setPartner({..._partner,name:e.target.value});}} className='partner-input' placeholder={t('authentication.nom')} type='text' />
      </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('livreur.admin')}</label>
        <Select isDisabled={!UserState.is_staff && !isNotNew} value={selectUser} options={users} onChange={(value,action)=>{setPartner({..._partner,email:value.value});}} className='partner-input' />
        {
          //<input disabled={!_partner.owned} value={_partner.email} onChange={e=>{setPartner({..._partner,email:e.target.value});}} className='partner-input' placeholder='email' type='email' />
        }
        </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('authentication.telephone')}</label>
        <input disabled={!_partner.owned && !isNotNew} value={_partner.phone} onChange={e=>{setPartner({..._partner,phone:e.target.value});}} className='partner-input' pattern="+269-[0-9]{3}-[0-9]{2}-[0-9]{2}" type='tel' placeholder={t('authentication.nom')} />
      </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('user-info.addresse')}</label>
        <div className='partner-input' style={{border:'none'}}>
          <div style={{padding:'5px',margin:'auto',width:'100%',display:'inline-block'}}>
            <Select placeholder={t('user-info.addresse')} onChange={(value,action)=>{setPartner({..._partner,address:value});}} value={_partner.address} isDisabled={!_partner.owned && !isNotNew} options={locations} />
          </div>
        </div>
      </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('produit.description')}</label>
        <textarea disabled={!_partner.owned && !isNotNew} value={_partner.description} onChange={e=>{setPartner({..._partner,description:e.target.value});}} style={{height:'60px',borderRadius:'5px'}} className='partner-input-textarea' placeholder={t('produit.description')} />
      </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('livreur.logo')}</label>
        {Logo()}
      </div>

      <div className='partner-div'>
        <label className='partner-label'>{t('livreur.identite')}</label>
        {Identite()}
      </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('livreur.rib')}</label>
        {Rib()}
      </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('livreur.engagement')}</label>
        <input disabled={!_partner.owned && !isNotNew} className='partner-input' style={{height:'40px', borderRadius:'5px'}} type='button' value={t('livreur.telecharger')}/>
      </div>
      <div className='partner-div'>
        { /*(_partner.owned || UserState.is_staff) && 
        <>
          <label className='partner-label'>Appareil de confiance : </label>
          <div style={{margin:'auto'}} className='partner-input'>
            {(_partner.owned) && <DeviceRegistration owned={_partner.owned} partner={'partner'} partner_id={_partner.id} device={_partner.device} />}
          </div>
        </>*/}
      </div>
      { UserState.is_staff &&
        <div className='partner-div'>
            <label className='partner-label'>{t('sales.colis')} </label>
            <div className='partner-input' style={{}}>
                <PartnerOrders partner_id={_partner.id} close_btn={false}/>
            </div>
        </div>
  }
    { (_partner.owned || isNotNew) &&
      <div className='partner-div' style={{height:'40px',textAlign:'center',margin:'auto',marginTop:'20px',width:'60%'}}>
        <ButtonLoader loading={loading.loading} disabled={(!_partner.owned || !UserState.is_staff) && !isNotNew} onSubmit={SavePartner} style={{backGroundColor:'lightgreen'}} text={loading.text} />
      </div>
      }
    </div>
  )
}

export default Partner
